import React from 'react';
import Develop from './Develop';
import Gisprocessing from './Gisprocessing'

const CategoriesSection = () => {
  const categories = [
    {
      id: 1,
      title: "Разработка",
      description: "Разработка программного обеспечения в области пространственных данных. Мы создаем инновационное программное обеспечение для обработки, визуализации и управления геопространственной информацией. Наши решения базируются на сервисах OGC, ArcGIS REST API и собственных решениях",
      icon: "/images/arrow-right.svg",
      bgColor: "grey-light"
    },
    {
      id: 2,
      title: "Обработка пространственных данных",
      description: "Поможем обработать пространственные данные любых форматов и размеров. Оцифровка, приведение к топологическим правилам, наполнение атрибутивной информацией",
      icon: "/images/arrow-right.svg",
      bgColor: "grey-light"
    },
    {
      id: 3,
      title: "Настройка ГИС-серверных приложений",
      description: "Настрим ГИС-сервисы на базе QGISServer, Geoserver, ArcGISServer и других систем",
      icon: "/images/arrow-right.svg",
      bgColor: "grey-light"
    }
  ];

  const images = [
    "/images/gis-layers.svg",
    "/images/Logomap.svg",
    "/images/gis-server.png"
  ];

  return (
    <section className="categories-section" id="categories">
      <div className="container">
        <h2 className="section-title">Наши Услуги</h2>
       

        <div className="categories-grid">
          {/* Первый ряд */}
          <div className={`category-card ${categories[0].bgColor}`}
              onClick={() => window.location.href = "#dev"}
              style={{ cursor: "pointer" }}
          >
            <h3>{categories[0].title}</h3>
            <p>{categories[0].description}</p>
             <div className="category-icon">
              <img src={categories[0].icon} alt={categories[0].title} />
             </div>
          </div>
          
          <div className="category-image">
            <img 
              src={images[0]} 
              alt="SpatialData" 
              className="animate-fade-in"
              style={{ animationDuration: '2000ms' }}
            />
          </div>
          
          <div className={`category-card ${categories[1].bgColor}`}
            onClick={() => window.location.href = "#gis"}
            style={{ cursor: "pointer" }}>
            <h3>{categories[1].title}</h3>
            <p>{categories[1].description}</p>
            <div className="category-icon">
              <img src={categories[1].icon} alt={categories[1].title} />
            </div>
          </div>

          {/* Второй ряд */}
          <div className="category-image">
            <img 
              src={images[1]} 
              alt="Geonames" 
              className="animate-fade-in"
              style={{ animationDuration: '2000ms', animationDelay: '200ms' }}
            />
          </div>
          
          <div className={`category-card ${categories[2].bgColor}`}>
            <h3>{categories[2].title}</h3>
            <p>{categories[2].description}</p>
            <div className="category-icon">
              <img src={categories[2].icon} alt={categories[2].title} />
            </div>
          </div>
          
          <div className="category-image">
            <img 
              src={images[2]} 
              alt="GisServers" 
              className="animate-fade-in"
              style={{ animationDuration: '2000ms', animationDelay: '400ms' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;